export class AgentMessages {
	public static AgentSuccessEditMessage: string = "Agent(s) has been updated";

	public static AgentErrorSave: string = "Error saving agent(s)!";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class AttachmentMessages {
	public static AttachmentLoadError: string = "Error loading attachemnt!";

	public static AttachmentSaveError: string = "Error loading attachment!";

	public static AttachmentDeleteError: string = "Error deleting attachment!";

	public static AttachmentDeleteConfirmation: string = "Are you sure you want to delete {number} attachment(s)(s)?";

	public static AttachmentDeletedMessage: string = "Selected attachments has been deleted.";

	public static FileRequiredError: string = "You have to select file to upload!";

	public static AttachmentFileUploadSucces: string = "File Uploaded successfully";

	public static AttachmentNameValidationMessage: string = "Name field cannot be empty";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class BonusMessages {
	public static NewBonusSaveSuccess: string = "New bonus has been created";

	public static NewBonusEditSuccess: string = "New bonus has been updated";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class BuyerMessages {
	public static BuyerSuccessSaveMessage: string = "Successfully saved buyer.";

	public static BuyerSuccessEditMessage: string = "Buyer has been updated";

	public static BuyerErrorSave: string = "Error saving buyer!";

	public static BuyerDeleteMessage: string = "Selected buyer(s) has been deleted.";

	public static BuyerDeleteConfirmation: string = "Are you sure you want to delete {number} buyer(s)(s)?";

	public static BuyerErrorDeleteMessage: string = "Error deleting buyer(s)!";

	public static BuyerAssociationSuccessSaveMessage: string = "Successfully saved buyer association.";

	public static BuyerAssociationSuccessEditMessage: string = "Buyer association has been updated";

	public static BuyerAssociationErrorSave: string = "Error saving buyer association!";

	public static BuyerAssociationDeleteMessage: string = "Selected buyer association(s) has been deleted.";

	public static BuyerAssociationDeleteConfirmation: string = "Are you sure you want to delete {number} buyer association(s)(s)?";

	public static BuyerAssociationErrorDeleteMessage: string = "Error deleting buyer association(s)!";

	public static BuyerTaxInformationSuccessSaveMessage: string = "Successfully saved buyer tax information.";

	public static BuyerTaxInformationSuccessEditMessage: string = "Buyer tax information has been updated";

	public static BuyerTaxInformationErrorSave: string = "Error saving buyer tax information!";

	public static BuyerLoanoutSuccess: string = "Buyer loanout(s) has been created";

	public static BuyerLoanoutEditSuccess: string = "Buyer loanout has been updated";

	public static BuyerLoanoutErrorSave: string = "Error saving buyer loanout!";

	public static BuyerLoanoutDeleteConfirmation: string = "Are you sure you want to delete {number} buyer loanout(s)(s)?";

	public static BuyerLoanoutDeleteMessage: string = "Selected buyer loanout(s) has been deleted.";

	public static BuyerLoanoutErrorDeleteMessage: string = "Error deleting buyer loanout(s)!";

	public static BuyerAccountingPeriodDateInvalidMessage: string = "Invalid Date";

	public static BuyerAccountingPeriodDateDuplicateErrorMessage: string = "Duplicate period date";

	public static BuyerNoteSuccess: string = "Buyer note has been created";

	public static BuyerNoteEditSuccess: string = "Buyer note has been updated";

	public static BuyerNoteErrorSave: string = "Error saving buyer note!";

	public static BuyerNoteDeleteConfirmation: string = "Are you sure you want to delete {number} buyer note(s)(s)?";

	public static BuyerNoteDeleteMessage: string = "Selected buyer note has been deleted.";

	public static BuyerNoteErrorDeleteMessage: string = "Error deleting buyer note!";

	public static BuyerAttachmentSuccess: string = "Buyer Attachment has been created";

	public static BuyerAttachmentEditSuccess: string = "Buyer Attachment has been updated";

	public static BuyerAttachmentErrorSave: string = "Error saving buyer Attachment!";

	public static BuyerAttachmentDeleteConfirmation: string = "Are you sure you want to delete {number} buyer Attachment(s)(s)?";

	public static BuyerAttachmentDeleteMessage: string = "Selected buyer Attachment has been deleted.";

	public static BuyerAttachmentErrorDeleteMessage: string = "Error deleting buyer Attachment!";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class ClientMessages {
	public static ClientSuccessSaveMessage: string = "Successfully saved client.";

	public static ClientSuccessEditMessage: string = "Client has been updated";

	public static ClientErrorSave: string = "Error saving client!";

	public static ClientDeleteMessage: string = "Selected client(s) has been deleted.";

	public static ClientDeleteConfirmation: string = "Are you sure you want to delete {number} client(s)(s)?";

	public static ClientErrorDeleteMessage: string = "Error deleting client(s)!";

	public static ClientRepresentationSuccessSaveMessage: string = "Successfully saved client representation.";

	public static ClientRepresentationSuccessEditMessage: string = "Client representation has been updated";

	public static ClientRepresentationErrorSave: string = "Error saving client representation!";

	public static ClientInformationSuccessSaveMessage: string = "Successfully saved client information.";

	public static ClientInformationSuccessEditMessage: string = "Client information has been updated";

	public static ClientInformationErrorSave: string = "Error saving client information!";

	public static ClientAssociationSuccessSaveMessage: string = "Successfully saved client association.";

	public static ClientAssociationSuccessEditMessage: string = "Client association has been updated";

	public static ClientAssociationErrorSave: string = "Error saving client association!";

	public static ClientAssociationDeleteMessage: string = "Selected client association(s) has been deleted.";

	public static ClientAssociationDeleteConfirmation: string = "Are you sure you want to delete {number} client association(s)(s)?";

	public static ClientAssociationErrorDeleteMessage: string = "Error deleting client association(s)!";

	public static ClientLoanoutSuccess: string = "Client loanout(s) has been created";

	public static ClientLoanoutEditSuccess: string = "Client loanout has been updated";

	public static ClientLoanoutErrorSave: string = "Error saving client loanout!";

	public static ClientLoanoutDeleteConfirmation: string = "Are you sure you want to delete {number} client loanout(s)(s)?";

	public static ClientLoanoutDeleteMessage: string = "Selected client loanout(s) has been deleted.";

	public static ClientLoanoutErrorDeleteMessage: string = "Error deleting client loanout(s)!";

	public static ClientNoteSuccess: string = "Client note has been created";

	public static ClientNoteEditSuccess: string = "Client note has been updated";

	public static ClientNoteErrorSave: string = "Error saving client note!";

	public static ClientNoteDeleteConfirmation: string = "Are you sure you want to delete {number} client note(s)(s)?";

	public static ClientNoteDeleteMessage: string = "Selected client note has been deleted.";

	public static ClientNoteErrorDeleteMessage: string = "Error deleting client note!";

	public static ClientAttachmentSuccess: string = "Client Attachment has been created";

	public static ClientAttachmentEditSuccess: string = "Client Attachment has been updated";

	public static ClientAttachmentErrorSave: string = "Error saving client Attachment!";

	public static ClientAttachmentDeleteConfirmation: string = "Are you sure you want to delete {number} client Attachment(s)(s)?";

	public static ClientAttachmentDeleteMessage: string = "Selected client Attachment has been deleted.";

	public static ClientAttachmentErrorDeleteMessage: string = "Error deleting client Attachment!";

	public static ClientParticipantSuccess: string = "Client participant(s) has been created";

	public static ClientParticipantEditSuccess: string = "Client participant has been updated";

	public static ClientParticipantErrorSave: string = "Error saving client participant!";

	public static ClientParticipantDeleteConfirmation: string = "Are you sure you want to delete {number} client participant(s)(s)?";

	public static ClientParticipantDeleteMessage: string = "Selected client participant(s) has been deleted.";

	public static ClientParticipantErrorDeleteMessage: string = "Error deleting client participant(s)!";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class ContactMessages {
	public static ContactSuccessSaveMessage: string = "Successfully saved contact.";

	public static ContactSuccessEditMessage: string = "Contact has been updated";

	public static ContactErrorSave: string = "Error saving contact!";

	public static ContactDeleteMessage: string = "Selected contact(s) has been deleted.";

	public static ContactDeleteConfirmation: string = "Are you sure you want to delete {number} contact(s)(s)?";

	public static ContactErrorDeleteMessage: string = "Error deleting contact(s)!";

	public static ContactInformationSuccessSaveMessage: string = "Successfully saved contact information.";

	public static ContactInformationSuccessEditMessage: string = "Contact information has been updated";

	public static ContactInformationErrorSave: string = "Error saving contact information!";

	public static ContactAssociationSuccessSaveMessage: string = "Successfully saved contact association.";

	public static ContactAssociationSuccessEditMessage: string = "Contact association has been updated";

	public static ContactAssociationErrorSave: string = "Error saving contact association!";

	public static ContactAssociationDeleteMessage: string = "Selected contact association(s) has been deleted.";

	public static ContactAssociationDeleteConfirmation: string = "Are you sure you want to delete {number} contact association(s)(s)?";

	public static ContactAssociationErrorDeleteMessage: string = "Error deleting contact association(s)!";

	public static ContactLoanoutSuccess: string = "Contact loanout(s) has been created";

	public static ContactLoanoutEditSuccess: string = "Contact loanout has been updated";

	public static ContactLoanoutErrorSave: string = "Error saving contact loanout!";

	public static ContactLoanoutDeleteConfirmation: string = "Are you sure you want to delete {number} contact loanout(s)(s)?";

	public static ContactLoanoutDeleteMessage: string = "Selected contact loanout(s) has been deleted.";

	public static ContactLoanoutErrorDeleteMessage: string = "Error deleting contact loanout(s)!";

	public static ContactNoteSuccess: string = "Contact note has been created";

	public static ContactNoteEditSuccess: string = "Contact note has been updated";

	public static ContactNoteErrorSave: string = "Error saving contact note!";

	public static ContactNoteDeleteConfirmation: string = "Are you sure you want to delete {number} contact note(s)(s)?";

	public static ContactNoteDeleteMessage: string = "Selected contact note has been deleted.";

	public static ContactNoteErrorDeleteMessage: string = "Error deleting contact note!";

	public static ContactAttachmentSuccess: string = "Contact Attachment has been created";

	public static ContactAttachmentEditSuccess: string = "Contact Attachment has been updated";

	public static ContactAttachmentErrorSave: string = "Error saving contact Attachment!";

	public static ContactAttachmentDeleteConfirmation: string = "Are you sure you want to delete {number} contact Attachment(s)(s)?";

	public static ContactAttachmentDeleteMessage: string = "Selected contact Attachment has been deleted.";

	public static ContactAttachmentErrorDeleteMessage: string = "Error deleting contact Attachment!";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class DataMessages {
	public static DataNotUpdateMessage: string = "Data is not updated";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class DealMessages {
	public static DealSaveSuccessMessage: string = "Successfully saved Deal information.";

	public static DealNotesSaveSuccess: string = "Deal Notes has been created";

	public static DealNoteDefaultNoteLanguageSaveSuccess: string = "Deal Note(s) Default Note Language has been created";

	public static DealNoteDefaultNoteLanguageEditSuccess: string = "Deal Note(s) Default Note Language has been updated";

	public static DealNoteDefaultNoteLanguageDeleteConfirmation: string = "Are you sure you want to delete {number} Deal Note(s) Default Note Language(s)?";

	public static DealNoteDefaultNoteLanguageDeletedMessage: string = "Selected Deal Note(s) Default Note Language has been deleted.";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class TVPMessages {
	public static AttachmentDeleteConfirmation: string = "Are you sure you want to delete {number} Attachment(s)?";

	public static AttachmentDeleteSuccessItemMessage: string = "Attachment has been deleted";

	public static AttachmentDeleteSuccessItemsMessage: string = "Attachments have been deleted";

	public static AttachmentLDeleteError: string = "Error deleting Attachment!";

	public static AttachmentNameValidation: string = "Name field cannot be empty";

	public static AttachmentFileUploadedSuccess: string = "Attachment has been uploaded";

	public static AttachmentAddedSuccess: string = "Attachment has been created";

	public static FileRequiredError: string = "You have to select file to upload!";

	public static NoteAddedSuccess: string = "Note has been created";

	public static NoteDeleteSuccessItemMessage: string = "Note has been deleted";

	public static NoteDeleteSuccessItemsMessage: string = "Notes have been deleted";

	public static NoteDeactivateSuccessItemMessage: string = "Note has been deleted";

	public static NoteDeactivateSuccessItemsMessage: string = "Notes have been deleted";

	public static NoteEditSuccess: string = "Note has been updated";

	public static NoteDeleteConfirmation: string = "Are you sure you want to delete {number} Note(s)?";

	public static NoteDeactivateConfirmation: string = "Are you sure you want to deactivate Note?";

	public static PackageAddedSuccess: string = "Package has been created";

	public static PackageEditSuccess: string = "Package has been updated";

	public static PaymentAddedSuccess: string = "Payment has been created";

	public static PaymentEditSuccess: string = "Payment has been updated";

	public static PaymentDeactivatedSuccess: string = "Selected Payment has been deactivated.";

	public static PaymentDeactivatedError: string = "Deactivation Error";

	public static PaymentDeactivatedConfirmation: string = "Are you sure you want to deactivate Payment?";

	public static DealAddedSuccess: string = "Deal has been created";

	public static DealAddedFromPackageSuccess: string = "A new Deal has been created from this Package Deal.";

	public static DealEditSuccess: string = "Deal has been updated";

	public static BookingAddedSuccess: string = "Booking has been created";

	public static BookingEditSuccess: string = "Booking has been updated";

	public static PackageElementAddedSuccess: string = "Package Element has been created";

	public static PackageElementEditSuccess: string = "Package Element has been updated";

	public static PackageAgencyAddedSuccess: string = "Agency has been created";

	public static PackageAgencyEditSuccess: string = "Agency has been updated";

	public static CurrencyValidationMessage: string = "Field must contain only decimal number";

	public static PackageElementDeleteConfirmation: string = "Are you sure you want to delete {number} Package Element(s)?";

	public static PackageAgencyDeleteConfirmation: string = "Are you sure you want to delete {number} Agency(s)?";

	public static PackageDeleteConfirmation: string = "Are you sure you want to delete {number} Package(s)?";

	public static PackageDeactivateConfirmationWithCount: string = "Are you sure you want to deactivate {number} Package?";

	public static PackageDeactivateConfirmation: string = "Are you sure you want to deactivate Package?";

	public static PackageActivateConfirmation: string = "Are you sure you want to activate Package?";

	public static BookingDeleteConfirmation: string = "Are you sure you want to delete {number} Booking(s)?";

	public static BeBookingDeleteConfirmation: string = "Are you sure you want to delete {number} Backend Booking(s)?";

	public static BookingDeactivateConfirmationWithCount: string = "Are you sure you want to deactivate {number} Booking?";

	public static BeBookingDeactivateConfirmationWithCount: string = "Are you sure you want to deactivate {number} Backend Booking?";

	public static BookingDeactivateConfirmation: string = "Are you sure you want to deactivate Booking?";

	public static BookingActivateConfirmation: string = "Are you sure you want to activate Booking?";

	public static BookingActivateConfirmationWithCount: string = "Are you sure you want to activate {number} Booking?";

	public static PackageElementDeleteSuccessItemMessage: string = "Package Element has been deleted";

	public static PackageElementDeleteSuccessItemsMessage: string = "Package Elements have been deleted";

	public static PackageAgencyDeleteSuccessItemMessage: string = "Agency has been deleted";

	public static PackageAgencyDeleteSuccessItemsMessage: string = "Agencies have been deleted";

	public static BookingDeleteSuccessItemMessage: string = "Booking has been deleted";

	public static BookingDeleteSuccessItemsMessage: string = "Bookings have been deleted";

	public static BookingDeacitivateSuccessItemMessage: string = "Booking has been deactivated";

	public static BookingDeacitivateSuccessItemsMessage: string = "Bookings have been deactivated";

	public static BookingActivateSuccessItemMessage: string = "Booking has been activated";

	public static BookingActivateSuccessItemsMessage: string = "Bookings have been activated";

	public static BookingDeactivateNotAllMessage: string = "Some of selected Bookings can't be deactivated.";

	public static PackageDeleteSuccessItemMessage: string = "Package has been deleted";

	public static PackageDeleteSuccessItemsMessage: string = "Packages have been deleted";

	public static PackageDeactivateSuccessItemMessage: string = "Package has been deactivated";

	public static PackageDeactivateSuccessItemsMessage: string = "Packages have been deactivated";

	public static PackageActivateSuccessItemMessage: string = "Package has been activated";

	public static PackageActivateSuccessItemsMessage: string = "Packages have been activated";

	public static PreCrmEditSuccess: string = "Pre Crm Data has been updated";

	public static PackageDeactivateNotAllMessage: string = "Some of selected Packages can't be deactivated.";

	public static DealIsUsedMessage: string = "Selected Deal is already assigned to different Package.";

	public static DealIsDeleted: string = "Deal is deleted.";

	public static BookingIsDeleted: string = "Booking is deleted.";

	public static BookingIsInactive: string = "Booking is inactive.";

	public static PackageIsInactive: string = "Package is inactive.";

	public static PackageIsDeleted: string = "Package is deleted.";

	public static BackendBookingExistMessage: string = "Backend Booking already exist.";

	public static BookingCancelConfirmation: string = "Are you sure you want to cancel Booking?";

	public static BookingCancelSuccessItemMessage: string = "Booking has been canceled";

	public static BackendBookingCancelConfirmation: string = "Are you sure you want to cancel Backend Booking?";

	public static BackendBookingCancelSuccessItemMessage: string = "Backend Booking has been canceled";

	public static ServiceTypeChanged: string = "Service Type has been updated.";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class PersonalAppearanceMessages {
	public static PASuccessSaveMessage: string = "Successfully saved Deal Info.";

	public static PASuccessEditMessage: string = "Deal Info has been updated";

	public static PAErrorSave: string = "Error saving Deal Info!";

	public static PADeleteMessage: string = "Selected Personal Appearance(s) has been deleted.";

	public static PADeleteConfirmation: string = "Are you sure you want to delete {number} Personal Appearance(s)(s)?";

	public static PAErrorDeleteMessage: string = "Error deleting Personal Appearance(s)!";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class EngagementMessages {
	public static EngagementNewSuccess: string = "Engagement has been created";

	public static EngagementSaveSuccess: string = "Successfully saved Engagement.";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class ExpenseMessages {
	public static ExpenseDeletedMessage: string = "Selected Expense has been deleted.";

	public static ExpenseSaveSuccess: string = "Expense has been created";

	public static ExpenseInvalidCancelMessage: string = "There are invalid inputs. Do you want to cancel your changes?";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class UserMessages {
	public static UserNotAvailable: string = "User Not Available";

	public static UserErrorLoad: string = "Error loading user!";

	public static UserErrorSave: string = "Error saving user!";

	public static UserErrorDelete: string = "Error deleting user!";

	public static UserDeleteConfirmation: string = "Are you sure you want to delete {number} user(s)(s)?";

	public static UserDeactivateConfirmation: string = "Are you sure you want to deactivate user?";

	public static UserDeleteMessage: string = "Selected user has been deleted.";

	public static UserDeactivateMessage: string = "Selected user has been deactivated.";

	public static UserNewMessage: string = "User has been created";

	public static UserSuccessEditMessage: string = "User has been updated";

	public static UserSuccessSaveMessage: string = "Successfully saved user.";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class MerchendiseMessages {
	public static MerchendiseDeleteConfirmation: string = "Are you sure you want to delete {number} merchendise(s)(s)?";

	public static MerchendiseDeletedMessage: string = "Selected merchendise(s) has been deleted.";

	public static MerchendiseNewSuccess: string = "Merchendise has been created";

	public static MerchendiseEditSuccess: string = "Merchendise has been updated";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class NoteMessages {
	public static NoteUploadSuccess: string = "Note has been created";

	public static NoteEditSuccess: string = "Note has been updated";

	public static NoteDeletedMessage: string = "Selected note(s) has been deleted.";

	public static NoteLoadError: string = "Error loading note!";

	public static NoteSaveError: string = "Error loading note!";

	public static NoteDeleteError: string = "Error deleting note!";

	public static NoteDeleteConfirmation: string = "Are you sure you want to delete {number} note(s)(s)?";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class PaymentMessages {
	public static PaymentSaveSuccess: string = "Payment has been created";

	public static PaymentDeactivateConfirmation: string = "Are you sure you want to deactivate Payment(s)?";

	public static PaymentDecativatationMessage: string = "Selected Payment has been deactivated.";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class RevenueMessages {
	public static RevenueSaveSuccess: string = "Revenue has been created";

	public static RevenueBonusDeleteConfirmation: string = "Are you sure you want to delete {number} revenue bonus(s)(s)?";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class ShowMessages {
	public static ShowScheduleSaveSuccessMessage: string = "Successfully saved Show Schedule.";

	public static ShowScheduleDeleteConfirmation: string = "Are you sure you want to delete {number} show(s)(s)?";

	public static ShowDeletedMessage: string = "Selected show(s) has been deleted.";

	public static ShowSaveSuccess: string = "Show has been created";

	public static ShowEditSuccess: string = "Show has been updated";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class TaxMessages {
	public static NewTaxLSaveSuccess: string = "Tax has been created";

	public static NewTaxLEditSuccess: string = "Tax has been updated";

	public static TaxDeleteConfirmation: string = "Are you sure you want to delete {number} Tax(es)(s)?";

	public static TaxDeletedMessage: string = "Selected Tax(s) has been deleted.";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class TicketScalingMessages {
	public static TicketScalingLSaveSuccess: string = "Ticket scaling has been created";

	public static TicketScalingLEditSuccess: string = "Ticket scaling has been updated";

	public static TicketScalingLDeleteConfirmation: string = "Are you sure you want to delete {number} Ticket Scaling(s)(s)?";

	public static TicketScalingLDeletedMessage: string = "Selected Ticket Scaling(s) has been deleted.";

	public static TicketScalingMinLengthValidationMessage: string = "Length should be atleast 3.";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class CommissionMessages {
	public static CommissionSuccessSaveMessage: string = "Successfully saved commission.";

	public static CommissionSuccessEditMessage: string = "Commission has been updated";

	public static CommissionErrorSave: string = "Error saving commission!";

	public static CommissionDeleteMessage: string = "Selected commission(s) has been deleted.";

	public static CommissionDeleteConfirmation: string = "Are you sure you want to delete {number} commission(s)(s)?";

	public static CommissionErrorDeleteMessage: string = "Error deleting commission(s)!";

	public static CommissionSuccessDeleteMessate: string = "Successfully deleted commission.";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



export class FileServiceMessages {
}



export class GridMessages {
	public static GridEditSuccess: string = "View has been updated";

	public static GridAddedSuccess: string = "View has been created";

	public static GridDeleteConfirmation: string = "Are you sure you want to delete View?";

	public static GridDeleteSuccessItemMessage: string = "View has been deleted";

	public static BaseErrorMessage: string = "Something went wrong.";

	public static ValidationError: string = "Validation errors";

	public static ErrorRequiredField: string = "Please fill the required field.";

	public static BeforeRefreshMessage: string = "You have unsaved changes. Are you sure you want to leave this page?";

	public static RequiredValidationMessage: string = "Required";

	public static InvalidFormatValidationMessage: string = "Invalid Format";

	public static InvalidFormMessage: string = "Form isn't valid.";

	public static OnlyNumbersMessage: string = "Field must contain only numbers";

	public static DiscardChanges: string = "Are you sure you want to discard changes?";

}



